import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Features } from '../../../shared/store/appState';
import { ProfileNotificationsState } from '../reducers/profileNotifications.reducer';



export const currentProfileNotificationsFeatureSelector =
    createFeatureSelector<ProfileNotificationsState>(Features.Notifications);

export const selectAllNotifications = createSelector(
    currentProfileNotificationsFeatureSelector,
    (state: ProfileNotificationsState) => state.notifications.items
);

export const selectNotificationsIsLoading = createSelector(
    currentProfileNotificationsFeatureSelector,
    (state: ProfileNotificationsState) => state.isLoading
);

export const selectCountUnreadableNotifications = createSelector(
    currentProfileNotificationsFeatureSelector,
    (state: ProfileNotificationsState) =>
        state.notifications.items.filter((n) => !n.isRead).length
);

export const selectUnreadableNotifications = createSelector(
    currentProfileNotificationsFeatureSelector,
    (state: ProfileNotificationsState) =>
        state.notifications.items.filter((n) => !n.isRead)
);

export const selectPastNotifications = createSelector(
    currentProfileNotificationsFeatureSelector,
    (state: ProfileNotificationsState) =>
        state.notifications.items.filter((n) => n.isRead)
);

export const selectPagedNotifications = createSelector(
    currentProfileNotificationsFeatureSelector,
    (state: ProfileNotificationsState) => state.notifications
);
